import { Component, OnInit, Injector } from '@angular/core';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { FiltersofficialsService } from '../../services/filtersofficials.service';
import { HttpClient } from '@angular/common/http';
import { OficialsStore, IOfficial } from '../../../common-page-components/stores/entities-store/officials-store';
import { combineLatest, map, mergeMap, filter, catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { of } from 'rxjs';
import { INews } from 'src/app/common-page-components/news-panel/news-panel.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-bootstrap-officials',
  templateUrl: './bootstrap-officials.component.html',
  styleUrls: ['./bootstrap-officials.component.scss']
})
export class BootstrapOfficialsComponent extends TableAbstractComponent implements OnInit {
  /**
   * A news Array of athletes
   *
   * @type {Array<INews>}
   * @memberof BootstrapOfficialsComponent
   */
  news: Array<INews>;
  /**
   * Headers of officials table
   *
   * @memberof BootstrapOfficialsComponent
   */
  headers = [
    { name: '', isSortable: false, sortProperty: '' },
    { name: 'Name', isSortable: true, sortProperty: 'NAME' },
    { name: "Country", isSortable: true, sortProperty: 'COUNTRY' },
    { name: 'World archery roles', isSortable: false, sortProperty: 'ASSOCIATIONCODE' },
  ]
  constructor(injector: Injector, public filter_services: FiltersofficialsService, http: HttpClient, private titleService: Title) {
    super(injector, filter_services, new OficialsStore(http, injector));
    http.get(environment.news_api.athletes_spotligth).pipe(catchError(e => of([]))).subscribe((next: any) => {
      this.news = next as any;
    });
    this.titleService.setTitle('Officials | World Archery');
    this.ShowNoResultsBox = true;
  }

  ngOnInit() {
    this.filter_services.getDataStreamWithFilters().pipe(
      combineLatest([this.reload.asObservable()]),
      map(([a, b]) => a),
      map(([order, text, active, country, archery_position]) => {
        const params = {
          SortBy: order.sortingSend,
          Name: text.text,
          Active: active.Value == null ? 0 : active.Value === true ? 1 : -1,
          Nationality: (country as any).NOC as any,
          WAPosition: archery_position.Value == null ? 0 : archery_position.Value === true ? 1 : 0
        }
        if (this.checkParamsForShowMessage(params) === false) {
          this.model.data = [];
          this.model.loadingRef = false;
          this.model.pagination.totalResults = 0;
          this.ShowNoResultsBox = true;
          this.customLoadMsg = 'Search or filter by country to find officials';
        } else {
          this.customLoadMsg = 'No results';
          this.ShowNoResultsBox = false;
        }
        return params;
      }),
      filter(a => this.checkParamsForShowMessage(a)),
      mergeMap(params => this.model.requestData(params, this.request_more_data))
    ).subscribe();
  }

  /**
   * A method for check if there's any correct param and send data.
   *
   * @param {*} params
   * @returns
   * @memberof BootstrapCoachesComponent
   */
  checkParamsForShowMessage(params: any) {
    return params.Nationality.toString().length > 0 || params.Name !== '';
  }

  /**
   * Method for get all positions of an offcial
   *
   * @param {IOfficial} official
   * @returns
   * @memberof BootstrapOfficialsComponent
   */
  getAllPositions(official: IOfficial) {
    let markUp =
      Object.keys(official.Association)
        .map(key => official.Association[key].filter(value => value.FunEnd.length === 0 ? true : (new Date(
          new Date(new Date(value.FundEnd).getTime() +
            Math.abs(new Date(value.FundEnd).getTimezoneOffset() * 60000))
        ) > new Date()))
          .map(association =>
            `<div class='center'>
        <span class="uppertext">${association.FunGroup} </span>
        <span class="uppertext-black"> ${association.FunName}</span>
        </div>`));
    markUp = Array.from(flatten(markUp)
      .reduce((a, b) => a.set(b, b), new Map()).values());
    return markUp.join(' ');

  }

  /**
   * Method for get all positions of an offcial
   *
   * @param {IOfficial} official
   * @returns
   * @memberof BootstrapOfficialsComponent
   */
  getAllPositionsName(official: IOfficial) {
    return Array.from(
      Object.keys(official.Association)
        .map(key => official.Association[key]
          .map(association => association.FunName))[0]
        .reduce((a, b) => a.set(b, b), new Map()).values())

  }

  /**
   * Get country name by code
   *
   * @param {string} NOC
   * @returns
   * @memberof BootstrapOfficialsComponent
   */
  getCountryName(NOC: string) {
    const flag = this.model.dependencies[0].entity.data.find(value => value.NOC === NOC);
    return flag != undefined ? flag.CShort : '';
  }
}

/**
 * A Function that flatt an array
 *
 * @param {*} arr
 * @returns
 */
export function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);
}
